export const REMOVE_QUERY_PARAMS_FROM_PAGE_URL = 'Web.PageInterface.v1_0.RemoveQueryParamsFromPageUrlMethod';
